/**
 * Created by hyr on 19/1/30.
 * 活动各种名称配置文件, 需要用户手动配置
 */
import { webviewInfo, util } from '@ali/amap-lib';

// todo 更换当前项目活动id
const actId = util.getUrlParam('act_id') || (webviewInfo.isPublic() ? '30d3dd1c' : '9720aad7');
export default {
  name: 'activity_2019_XXX', // 埋点名称
  aosLine: 'activity', // aos链接业务线
  aosName: 'invite_new', // aos链接名称
  activity: 'xxx', // aos通用模块活动名称
  actId, // 活动id
};
